<template>
<div class="container">
    <h3>Registro de actividades para la instalación de Planta Fotovoltaica</h3>
    <div class="text-left">
        <!--Modal ***********************-->
        <b-button variant="primary" @click.prevent="irInforme" ><i class="fas fa-plus-circle" ></i> Generar Informe</b-button>
        <!--<ModalAgregarSeguimiento></ModalAgregarSeguimiento>-->
        <!--Modal ***********************-->
    </div>

    <div class="accordion" id="accordionExample">
        <div class="card" v-for="(actividad, index) in traerDataSeguimientoProyectos" :key="index">
            <div class="card-header" id="headingOne">
                <h2 class="mb-0">
                    <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" :data-target="'#collapse'+index" aria-expanded="true" aria-controls="collapseOne" >
                        {{actividad.nombreproyecto}} - {{actividad.nombreinforme}} - {{actividad.actividad}}

                        <div :id="'collapse'+index" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                            <div class="card-body">                                
                                <p>Resumen Informe: <span v-html="actividad.descripcionactividad"></span></p>
                            </div>
                            <button class="btn btn-primary" @click.prevent="verInforme(index, actividad.nombreinforme)">Ver Informe</button>
                        </div>
                                    
                    </button>
                </h2>
            </div>

        </div>
    </div>

</div>
</template>

<script>
//import ModalAgregarSeguimiento from '../components/ModalAgregarSeguimiento.vue';


export default {
    name: 'Seguimiento',
    data(){
        return{
            imagenes:[],
            imagendesc:false,
        }
    },
    components: {
        //ModalAgregarSeguimiento
    },
    methods:{
        irInforme(){
            this.$router.push('/generarinforme')            
        },
        verInforme(index,informe){
            let union = index+'-'+informe
            this.$router.push(`/verinforme/${union}`);
        }
       
    },    
    computed: {
        traerDataSeguimientoProyectos() {
            return this.$store.getters.enviarDataSeguimientoProyectos.filter((element) => {
                return element.nombreproyecto.toLowerCase().includes(this.$store.state.busqueda.toLowerCase())
            });
        }
    }

}
</script>

<style>

</style>
